import { BaseFilterComponent } from './types';
import { Checkbox } from '@lifeomic/chroma-react/components/Checkbox';
import { CheckboxFilterOption } from '../options/types';
import { Filter } from '../../types';
import { useIntl } from 'react-intl';
import * as React from 'react';

export interface FilterCheckboxProps
  extends CheckboxFilterOption,
    BaseFilterComponent {}

export const FilterCheckbox: React.FC<FilterCheckboxProps> = ({
  injectedProps: { checkboxOption, searchKey },
  onFilterAdd,
  onFilterRemove,
  origin,
  selectedFilterOptions,
}) => {
  const { formatMessage } = useIntl();

  const [isChecked, setIsChecked] = React.useState<boolean>(
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    checkboxOption.searchValue,
  );

  // Handle case where item is de-selected from BagOfChips
  // instead of manually un-checked
  React.useEffect(() => {
    const state = Boolean(
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      selectedFilterOptions.find(
        filterOption => filterOption.searchKey === searchKey,
      ),
    );

    if (state !== isChecked) {
      setIsChecked(state);
    }
  }, [isChecked, searchKey, selectedFilterOptions]);

  const handleChange = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);

    const option: Filter = {
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      friendlyName: formatMessage(checkboxOption.intlLabel),
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      id: checkboxOption.id,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      origin,
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      searchKey,
      searchValue: newValue,
    };

    if (newValue) {
      onFilterAdd?.(option);
    }

    if (!newValue) {
      onFilterRemove?.(option);
    }
  };

  return (
    <Checkbox
      // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
      label={formatMessage(checkboxOption.intlLabel)}
      checked={isChecked}
      onChange={handleChange}
    />
  );
};
